import "./CustomHeader.css";
import MenuIcon from "@mui/icons-material/Menu";
import NaturalPersonAvatar from "assets/natural-person-avatar.svg";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  Chip,
} from "@mui/material";
import { useAppSelector } from "redux/hooks";
import ReduxCommonApi from "redux/common/ReduxCommonApi";
import { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import FAQDialog from "pages/homepage/FaqDialog";
import ReduxUserApi from "redux/user/ReduxUserApi";
import CommonConstants from "constants/CommonConstants";
import { useNavigate } from "react-router-dom";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import { createApi } from "util/ApiCreator";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { MessagePublicController } from "api/main/MessagePublicController";
import { RoleNames } from "models/auth/RoleNames";
import { hasRole } from "util/UtilityFunctions";
import { adminTheme } from "theme/adminTheme";

const CustomHeader = () => {
  const [badgeCount, setBadgeCount] = useState(0);

  useEffect(() => {
    getMessages();
  }, []);

  const handleNotificationClick = () => {
    navigate("messages");
    setBadgeCount(0);
    localStorage.setItem("hasClickedNotification", badgeCount + "");
  };

  const getMessages = async () => {
    let num = await messageApi.current.getCount();
    let clicked = localStorage.getItem("hasClickedNotification") || 0;
    if (+clicked !== num) {
      setBadgeCount(num);
    }
  };

  const common = useAppSelector((state) => state.common);
  const me = useAppSelector((state) => state.me);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const authApi = useRef(createApi("auth"));
  const messageApi = useRef(
    createApi("messagespublic") as MessagePublicController
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoff = () => {
    ReduxUserApi.logOffMe(authApi);
    navigate(CommonConstants.loginPathName);
  };

  const [modalOpen, setOpen] = useState(false);

  const isAdmin = hasRole(RoleNames.ADMIN, me?.info?.roles);
  const roleLabel = isAdmin ? "Administratorius" : "Vartotojas";

  return (
    <AppBar position="static" style={{ position: "relative", zIndex: "1" }}>
      <Toolbar
        disableGutters
        className={"customHeader-main"}
        style={{
          justifyContent:
            common?.sideMenuIsPermanent || common?.sideMenuIsHidden
              ? undefined
              : "space-between",
          backgroundColor: "white",
          color: "black",
        }}
      >
        {!common?.sideMenuIsPermanent && !common?.sideMenuIsHidden && (
          <Button
            variant={"text"}
            onClick={ReduxCommonApi.openSideMenu}
            disableRipple
          >
            <MenuIcon
              sx={{
                height: "32px",
                color: "black",
              }}
            />
          </Button>
        )}
        <Box style={{ display: "flex", height: "100%", alignItems: "center" }}>
          <Box
            onClick={() => navigate("/home")}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              padding: "0.5rem 1rem",
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                background: adminTheme.gradients.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AutoGraphIcon sx={{ color: "white", fontSize: 24 }} />
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: adminTheme.gradients.primary,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              recodinAI
            </Typography>
          </Box>
        </Box>
        <Box
          style={{
            marginLeft: "auto",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <Box className={"hide-on-mobile"}>
            <IconButton
              onClick={() => {
                navigate("messages");
                handleNotificationClick();
              }}
            >
              <Badge badgeContent={badgeCount} color="primary">
                <NotificationsIcon color="action" />
              </Badge>
            </IconButton>
          </Box>
          <Button
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <img
              src={NaturalPersonAvatar}
              style={{ paddingRight: "0.5rem", height: "46px", width: "46px" }}
              alt={"vartotojo piktograma"}
            />

            <Box
              className={"hide-on-mobile"}
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  style={{
                    fontSize: "12px",
                    color: "#617a96",
                    fontWeight: "700",
                  }}
                >
                  Prisijungęs kaip
                </Box>

                <Typography variant={"h6"} id={"me-fullname"}>
                  {me?.info?.email}
                </Typography>

                <Chip
                  label={roleLabel}
                  size="small"
                  sx={{
                    height: "20px",
                    fontSize: "11px",
                    fontWeight: 600,
                    mt: 0.5,
                    bgcolor: isAdmin
                      ? adminTheme.colors.primary
                      : adminTheme.colors.success,
                    color: "white",
                  }}
                />
              </Box>
              <KeyboardArrowDownIcon />
            </Box>
          </Button>
        </Box>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            onClick={handleLogoff}
            disableRipple
            style={{ display: "flex", alignItems: "center" }}
          >
            <LogoutIcon style={{ color: "red", marginRight: "0.5rem" }} />
            Atsijungti
          </MenuItem>
        </Menu>
      </Toolbar>
      <FAQDialog open={modalOpen} handleClose={() => setOpen(!modalOpen)} />
    </AppBar>
  );
};

export default CustomHeader;
